{
  "level": "mt03mv2",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03mv2",
    "objects": "AREAS.E3:mt03mv2.e3",
    "mesh": "TREES.E3:mt03mv2.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}